export const tags = new Map([
    ['de', 'German'],
    ['en', 'English'],
    ['en-gb', 'English (Great Britain)'],
    ['en-us', 'English (United States)'],
    ['es', 'Spanish (Spain)'],
    ['es-MX', 'Spanish (Mexico)'],
    ['fi', 'Finnish'],
    ['fr', 'French'],
    ['it', 'Italian'],
    ['ja', 'Japanese'],
    ['ko', 'Korean'],
    ['nl', 'Dutch'],
    ['pl', 'Polish'],
    ['pt', 'Portuguese (Portugal)'],
    ['pt-BR', 'Portuguese (Brazil)'],
    ['ru', 'Russian'],
    ['sv', 'Swedish'],
    ['zh-CN', 'Chinese (PRC)'],
    ['zh-TW', 'Chinese (Taiwan)'],
]);
